import css from './questionListFilters.module.scss';

import cx from 'classnames';
import { useNavigate } from 'react-router-dom';

import KeyBind from 'core/ui/KeyBind';
import { Icon } from 'core/ui/icons';

export const SearchInput = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (text: string) => void;
}) => (
  <input
    type="text"
    placeholder="Search..."
    className={css.searchInput}
    value={value}
    onChange={evt => onChange(evt.target.value)}
  />
);

export const SearchButton = ({ onClick }: { onClick: () => void }) => (
  <Icon icon="Magnifier" className={css.filterButton} onClick={onClick} />
);

export const AddQuestion = ({ onClick }: { onClick: () => void }) => (
  <>
    <Icon icon="Plus" className={css.filterButton} onClick={onClick} />
    <KeyBind onKeyDown={onClick} kkb={['F2', 'Shift+Equal']} />
  </>
);

export const PlayButton = ({ link }: { link: string }) => {
  const navigate = useNavigate();
  return (
    <Icon
      icon="Play"
      className={css.filterButton}
      onClick={() => void navigate(link)}
    />
  );
};

export const ToggleOptionsButton = ({
  active,
  onClick,
}: {
  active: boolean;
  onClick: () => void;
}) => (
  <Icon
    icon="Eye"
    className={cx(css.filterButton, active && css.active)}
    onClick={onClick}
  />
);
